import { keepPreviousData } from '@tanstack/query-core';

import { useApiV1Ctx } from '@/components/providers/v1-api';
import { Card, CardContent } from '@/components/ui/card';

import { useCsrAggregateDataCtx } from './board-csr-provider';
import { formatDurationFromMillis } from '@/lib/format';

export function DashboardStats() {
  const { searchState } = useCsrAggregateDataCtx();
  const { api } = useApiV1Ctx();
  const { data, isLoading } = api.externalCalls.getCallStatsExternalCallsAggregateCallStatsGet.useQuery(
    {
      query: {
        from_date: searchState.filters.dateRange.from.toISOString(),
        to_date: searchState.filters.dateRange.to.toISOString(),
      },
    },
    {
      refetchOnWindowFocus: false,
      placeholderData: keepPreviousData,
    }
  );

  return (
    <div className='grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4'>
      <Card>
        <CardContent>
          <div className='flex items-center justify-between space-x-2'>
            <div>
              <p className='text-muted-foreground text-sm font-medium'>Calls Analyzed</p>
              <p className='mt-1 text-2xl font-semibold text-gray-900'>{data?.calls_analyzed ?? 0}</p>
              <p className='text-muted-foreground mt-1 text-xs'>Total calls processed</p>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <div className='flex items-center justify-between space-x-2'>
            <div>
              <p className='text-muted-foreground text-sm font-medium'>Avg. Metrics Score</p>
              <p className='mt-1 text-2xl font-semibold text-gray-900'>{(data?.score_rate ?? 0).toFixed(2)}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <div className='flex items-center justify-between space-x-2'>
            <div>
              <p className='text-muted-foreground text-sm font-medium'>Booking Rate</p>
              <p className='mt-1 text-2xl font-semibold text-gray-900'>{data?.booking_rate ?? 0} %</p>
              <p className='text-muted-foreground mt-1 text-xs'>Appointment booked</p>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <div className='flex items-center justify-between space-x-2'>
            <div>
              <p className='text-muted-foreground text-sm font-medium'>Avg. Call Duration</p>
              <p className='mt-1 text-2xl font-semibold text-gray-900'>
                {formatDurationFromMillis(data?.avg_calls_duration_ms ?? 0, 'min')}
              </p>
              <p className='text-muted-foreground mt-1 text-xs'>Minutes per call</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
